import { MovieOpenRemoveIcon } from './MovieOpenRemoveIcon';

/**
 * author: Colton Wiscombe
 * id 1AA27DAA-CD6F-41C5-BB25-8860B368DC0B
 * name movie-open-remove
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-open-remove.svg
 * tags
 * - Video / Movie 
 */
export const ClapperboardOpenRemoveIcon = MovieOpenRemoveIcon;
export default ClapperboardOpenRemoveIcon